import React from "react"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { createRoot } from "react-dom/client"
import AiTargetingForm from "./AiTargetingForm"
import { validateTargetingConfig } from "./aiTargetingValidation"

const MySwal = withReactContent(Swal)

function AiTargetingModalContent({ initialConfig, onConfigChange }) {
  return (
    <div className="ai-targeting-modal">
      <div className="ai-targeting-modal__header">
        <div className="ai-targeting-modal__icon">
          <i className="fas fa-crosshairs"></i>
        </div>
        <h2 className="ai-targeting-modal__title">Configuration du ciblage IA</h2>
        <p className="ai-targeting-modal__subtitle">
          Définissez les critères de ciblage pour optimiser la diffusion de cette ressource.
        </p>
      </div>

      <AiTargetingForm
        initialConfig={initialConfig}
        defaultToggleDisabled={initialConfig.defaultToggleDisabled}
        isEditMode={initialConfig.isEditMode || false}
        existingTargetingAds={initialConfig.existingTargetingAds || []}
        onConfigChange={onConfigChange}
      />
    </div>
  )
}

export const openAiTargetingModal = async (initialConfig = {}) => {
  let targetingConfig = { ...initialConfig }
  let reactRoot = null

  return MySwal.fire({
    html: "<div id='react-ai-targeting-container'></div>",
    showCancelButton: true,
    confirmButtonText: '<i class="fas fa-check mr-1"></i> Valider',
    confirmButtonColor: "#133D94",
    cancelButtonText: "Annuler",
    cancelButtonColor: "#6b7280",
    showCloseButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    focusConfirm: false,
    width: "560px",
    customClass: {
      popup: "ai-targeting-modal__popup",
      confirmButton: "ai-targeting-modal__btn-confirm",
      cancelButton: "ai-targeting-modal__btn-cancel",
    },
    didOpen: () => {
      document.activeElement?.blur()
    },
    willOpen: () => {
      const container = document.getElementById("react-ai-targeting-container")
      if (container) {
        reactRoot = createRoot(container)
        reactRoot.render(
          <AiTargetingModalContent
            initialConfig={initialConfig}
            onConfigChange={(config) => (targetingConfig = config)}
          />
        )
      }
    },
    didClose: () => {
      if (reactRoot) {
        reactRoot.unmount()
        reactRoot = null
      }
    },
    preConfirm: () => {
      const result = validateTargetingConfig(targetingConfig, {
        maxDuration: initialConfig.maxDuration,
      })

      if (!result.valid) {
        Swal.showValidationMessage(result.message ?? "")

        return false
      }

      return targetingConfig
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return result.value
    }

    return false
  })
}
